// extracted by css-extract-rspack-plugin
export default {"toast":"_JWuW","progress":"TpDc8","animated-progress":"LvhEa"};